import { useEffect, useState } from 'react'
import { BASE_URL } from '../constants/urls';
import axios from 'axios';

const useStoreData = ({slug}) => {

    const [store, setstore] = useState({});
    const [loadingStore, setLoadingStore] = useState(true);
    const [errorStore, setErrorStore] = useState(null);

    useEffect(() => {

        const getStoreData = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/store`, {
                    params: { slug },
                    headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`}
                  }); 

                  setstore(res.data)
                  
            } catch (err)  {
                const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
                setErrorStore(msg);
            } finally {
              setLoadingStore(false)
            }
        }

        getStoreData();

    }, [slug])
  

   return { store, loadingStore, errorStore };
}

export default useStoreData